module.exports = __webpack_public_path__ + "img/new-gdl-logo-for-email.e0bd4794.png";